import { createFileRoute } from "@tanstack/react-router";
import { PortalProtectionV2Page } from "@/components/v2/pages/portal-protection-v2-page";

export const Route = createFileRoute("/portal/protection")({
  component: PortalProtectionV2Page,
});
